<template>
  <div class="summary-tooltip" :class="color">
    <button class="summary-tooltip-button" @click="open = !open" ref="button">
      <span class="label">
        <slot>Ver resumen generado por IA</slot>
      </span>
      <i v-icon:[`ia-${color}`] class="ia"></i>
    </button>
    <transition
      name="opacity"
      enter-class="scale-0 opacity-0"
      enter-to-class="scale-100 opacity-100 duration-500"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-0 opacity-0 duration-300"
    >
      <VSummaryTooltipContent
        v-if="open"
        :title="title"
        :content="content"
        :color="color"
        @close="open = false"
      ></VSummaryTooltipContent>
    </transition>
  </div>
</template>

<script>
import VSummaryTooltipContent from "./VSummaryTooltipContent.vue";

export default {
  name: "VSummaryAccordion",
  props: {
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "geb",
    },
  },
  components: {
    VSummaryTooltipContent,
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    const onKeyDownHandler = (event) => {
      if (this.open && (event.key === "Escape" || event.keyCode === 27)) {
        this.open = false;
      }
    };

    window.addEventListener("keydown", onKeyDownHandler);
  },
};
</script>

<style lang="scss" scoped></style>
